<template>
  <div class="entrega-mensais">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">
            Entrega da Prestação de Contas Mensal
          </span>
          <btn-voltar url="/entrega/prestacoes-contas-mensais" />
          <b-button size="sm" class="float-right m-1" @click="salvarPrestacao">
            <font-awesome-icon icon="save" class="mr-3" />
            Enviar Prestação
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <validation-observer ref="validationobserver" v-slot="{ }">
          <b-form @submit.prevent="salvarPrestacao">
            <b-row>
              <b-col cols="12" lg="6" xl="4">
                <b-form-group label-class="text-left" id="dt-input-group" label="Data de Entrega"
                  label-for="input-data-entrega">
                  <b-form-input readonly :disabled="true" id="input-data-entrega" v-model="dataEntrega" type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="6" xl="4">
                <validation-provider rules="required" v-slot="validationContext" name="tipoPrestacao">
                  <b-form-group id="input-group-type" label-size="md" label="Tipo de Prestação de Contas*">
                    <b-form-select id="select--tipo" @change="changePrestacao()" @input="getMeses" v-model="tipoPrestacao"
                      :state="getValidationState(validationContext)" :options="comboTipoPrestacaoContas">
                    </b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" lg="6" xl="4">
                <validation-provider rules="required" v-slot="validationContext" name="ano">
                  <b-form-group id="input-group-type" label-size="md" label="Ano">
                    <b-form-select id="select--exercicio" @change="changeAno()" :disabled="tipoPrestacao === ''"
                      v-model="exercicio" :options="comboAno" :state="getValidationState(validationContext)">
                    </b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" lg="6" xl="4">
                <validation-provider rules="required" v-slot="validationContext" name="mes">
                  <b-form-group id="input-group-type" label-size="md" label="Mês">
                    <b-overlay :show="loadingMeses">
                      <b-form-select id="select--mes" @change="changeMes()" :disabled="exercicio === ''"
                        @input="getTipoEntrega" v-model="mesRef" :options="comboMes"
                        :state="getValidationState(validationContext)">
                      </b-form-select>
                    </b-overlay>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" lg="6" xl="4">
                <validation-provider rules="required" v-slot="validationContext" name="tipoEntrega">
                  <b-form-group id="input-group-type" label-size="md" label="Tipo de Entrega">
                    <b-overlay :show="loadingTipoEntrega">
                      <b-form-select id="select-tipo-entrega" :disabled="mesRef === '' || exercicio === ''"
                        :state="getValidationState(validationContext)" v-model="tipoEntrega" :options="comboTipoEntrega">
                      </b-form-select>
                    </b-overlay>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" lg="6" xl="4">
                <validation-provider rules="required" v-slot="validationContext" name="arquivo">
                  <b-form-group id="input-group-type" label-size="md" label="Arquivo">
                    <b-form-file v-model="arquivo" :state="getValidationState(validationContext)"
                      placeholder="Selecione um arquivo">
                    </b-form-file>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider rules="required|max:50" v-slot="validationContext" name="descricao">
                  <b-form-group id="descricao" label="Descrição" label-for="input-descricao" label-class="text-left">
                    <b-form-textarea id="input-observacao" v-model="descricao"
                      :state="getValidationState(validationContext)" rows="3" max-rows="6">
                    </b-form-textarea>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import { store } from "@/store";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import pcmService from "@/services/entregas/pcmService";
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { SelectValue } from '@/types/select-value'

const CompProps = Vue.extend({
  name: 'ContasMensaisEntregaComponent',
  components: { BtnVoltar, ValidationProvider, ValidationObserver },
})

@Component
export default class ContasMensaisEntrega extends mixins(UtilsTS, CompProps) {
  @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
  comboAno: SelectValue[] = []
  comboMes: SelectValue[] = []
  comboTipoEntrega: SelectValue[] = []
  comboTipoPrestacaoContas: SelectValue[] = []
  dataEntrega = ''
  exercicio = ''
  mesRef = ''
  tipoPrestacao = ''
  tipoEntrega = ''
  descricao = ''
  loadingMeses = false
  loadingTipoEntrega = false
  arquivo: File | null = null

  async salvarPrestacao(): Promise<void> {
    let isValid = await this.validationobserver.validate()
    if (isValid) {
      store.blockScreen = true
      const data = new FormData()
      data.append("arquivo", this.arquivo ? this.arquivo : '')
      data.append("exercicio", this.exercicio)
      data.append("tipoPrestacao", this.tipoPrestacao)
      data.append("mesRef", this.mesRef)
      data.append("descricao", this.descricao)
      data.append("tipoEntrega", this.tipoEntrega)
      let response = await pcmService.salvarPrestacao(data)
      if (response && response.status == 200) {
        this.download('Arquivo_Download.pdf', response.data)
        this.$toast.error("Arquivo inconsistente, favor verificar o pdf gerado!")
        this.arquivo = null
      }
      else if (response && response.status == 201) {
        this.$toast.success("Prestação enviada com sucesso!")
        this.$router.push("/entrega/prestacoes-contas-mensais")
      }
      else {
        if (response && response.data) {
          let respText = JSON.parse(await response.data.text())
          this.$toast.error(respText.msg)
        }
        else
          this.$toast.error("Erro ao salvar prestação!")
        this.arquivo = null
      }
      store.blockScreen = false
    }
    else {
      this.$toast.error("Verifique se preencheu todos campos do formulário!")
    }
  }

  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }

  changePrestacao() {
    this.exercicio = ""
  }

  changeAno() {
    this.mesRef = ""
  }

  changeMes() {
    this.tipoEntrega = ""
  }

  async handleFileSeletion(evt, item) {
    if (!evt || !evt.target || !evt.target.files || evt.target.files.length === 0) {
      //this.$parent.errorMessage = "Não foi possível incluir";
      return;
    }
    const extension = evt.target.files[0].type;
    if (extension != "application/pdf") {
      //this.$parent.errorMessage = "Apenas arquivos PDF são aceitos";
      return;
    }
    //evt.target.files[0]

    //const response = await pcmService.sendFile(item.tipoArquivo, data, onUploadProgress);
    //this.isBusy = false;
  }

  async getMeses() {
    this.comboMes = []
    this.loadingMeses = true
    let meses = Object.entries(((await pcmService.getMeses(this.tipoPrestacao)).data))
    for (const [key, value] of meses)
      this.comboMes.push({ text: String(value), value: String(key) });
    this.loadingMeses = false
  }

  async getTipoEntrega() {
    this.comboTipoEntrega = []
    this.loadingTipoEntrega = true
    let tipos = Object.entries(((await pcmService.getTipoEntrega(this.tipoPrestacao, this.exercicio, this.mesRef)).data))
    for (const [key, value] of tipos)
      this.comboTipoEntrega.push({ text: String(value), value: String(key) });
    this.loadingTipoEntrega = false
  }

  download(filename, blob): void {
    let url = window.URL.createObjectURL(new Blob([blob]))
    let a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  async mounted() {
    try {
      store.blockScreen = true
      this.dataEntrega = this.getCurrentDate()
      this.comboAno = Object.keys((await pcmService.getExercicios()).data).map(r => {
        return { text: String(r), value: r }
      })

      this.comboTipoPrestacaoContas = (await pcmService.getTipoPrestacaoUG()).data.map(r => {
        return { text: r.Descricao, value: r.NumeroSistema }
      })
    } finally {
      store.blockScreen = false
    }
  }
};
</script>
<style>
.entrega-mensais label#input-dataValidade__value_ {
  padding-top: 10px !important;
}

.custom-file-input~.custom-file-label[data-browse]::after {
  content: 'Escolher' !important;
}
</style>